import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import * as dashboardActions from './../../actions/dashboardActions';
import * as CommonActions from '../../actions/commonActions';
import styles from './MarginComponent.less';
import ReactTooltip from 'react-tooltip';
import config from './../../config.js';
import i18next from 'i18next';
import HoverTable from './../../components/HoverTable/index.js';
import { applyStyleapplyToHover, setDirection } from './../../utils/utils';
import { bindActionCreators } from 'redux';
import MUIIcon from '../../components/IconMaterialUI/MUIIcon';

// const elementsData = [
//   { "classNames": "widgetheader", "elementType": "normal", "applyTo": "single", "tagNames": "div" },
//   { "classNames": "vericalDotIcon", "elementType": "normal", "applyTo": "single", "tagNames": "div" },
//   { "classNames": "closeBtn", "elementType": "normal", "applyTo": "single", "tagNames": "div" },
//   { "classNames": "widgettitle", "elementType": "normal", "applyTo": "alternative", "tagNames": "div" },
//   { "classNames": "normalfont", "elementType": "tag", "applyTo": "alternative", "tagNames": "tr" },
//   { "classNames": "statusBar", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
//   { "classNames": "mrgnBody", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
//   { "classNames": "mrgnLbl", "elementType": "normal", "applyTo": "all", "tagNames": "label" },
//   { "classNames": "mrgnField", "elementType": "normal", "applyTo": "all", "tagNames": "input" },
//   { "classNames": "mrgnTbl", "elementType": "normal", "applyTo": "single", "tagNames": "table" },
//   { "classNames": "mrgnTblHead", "elementType": "normal", "applyTo": "all", "tagNames": "th" },
//   { "classNames": "resizeLayout", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
//   { "classNames": "toolTip", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
//   { "classNames": "type-dark", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
// ];
const directionData = [
  { "classNames": "widgettitle", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
  { "classNames": "vericalDotIcon", "elementType": "normal", "applyTo": "single", "tagNames": "div" },
  { "classNames": "resizeLayout", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
  { "classNames": "mrgnWidgetbody", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
  { "classNames": "mrgnLbl", "elementType": "normal", "applyTo": "all", "tagNames": "label" },
  { "classNames": "mrgnInputDiv", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
  { "classNames": "mrgnField", "elementType": "normal", "applyTo": "all", "tagNames": "input" },
  { "classNames": "withOrderIcon", "elementType": "tag", "applyTo": "single", "tagNames": "i" },
];

class MarginComponent extends Component {
  state = {
    clickedRemove: false,
    comTel: '',
    deleteWidget: [],
    comEmail: '',
    showDeafultMarginWidgetHeight: true,
    detbean: [],
    showGridOptions: false,
    increaseRateColor: config.increaseRateColor
  }
  componentDidMount() {
    this.setState({ deleteWidget: this.props.deleteWidgetKey, detbean : Array.from(this.props.accBalMargBean.detonlBeanMap.values()) });
    this.setState({ comTel: this.props.userDetail.comTel });
    this.setState({ ComEmail: this.props.userDetail.ComEmail });
    if (this.props.marginHeight > 1) {
      this.setState({ showDeafultMarginWidgetHeight: true });
    } else {
      this.setState({ showDeafultMarginWidgetHeight: false });
    }
    const thisComponent = ReactDOM.findDOMNode(this);
    ////const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this), directionData, this.props.selectedLang);
    const hoverElementsClassNames = [
      { "elmToHover": thisComponent.getElementsByClassName('closeBtn')[0], "classNames": "closeBtn" },
      { "elmToHover": thisComponent.getElementsByClassName('vericalDotIcon')[0], "classNames": "vericalDotIcon" }
    ];
   // //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
  }
  // componentDidUpdate(preProps){
  //   const thisComponent = ReactDOM.findDOMNode(this);
  //   //const allCssStyleRules = this.props.selectedCssColorTheme;
  //   applyStyle(thisComponent, allCssStyleRules, elementsData);
  //  }

  componentWillReceiveProps(nextProps, nextState) {
    // if (this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme || this.state.showDeafultMarginWidgetHeight !== nextState.showDeafultMarginWidgetHeight) {
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //   //applyStyle(thisComponent, allCssStyleRules, elementsData);
    //   const hoverElementsClassNames = [
    //     { "elmToHover": thisComponent.getElementsByClassName('closeBtn')[0], "classNames": "closeBtn" },
    //     { "elmToHover": thisComponent.getElementsByClassName('vericalDotIcon')[0], "classNames": "vericalDotIcon" }
    //   ];
    //   //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    //   setDirection(ReactDOM.findDOMNode(this), directionData, nextProps.selectedLang);
    // }
    if (this.props.check !== nextProps.check) {
      if (this.props.accBalMargBean !== nextProps.accBalMargBean) {
        if (nextProps.accBalMargBean.detonlBeanMap)
          this.setState({ detbean: Array.from(nextProps.accBalMargBean.detonlBeanMap.values()) });
      }
    }
    if (this.state.deleteWidget !== nextProps.deleteWidgetKey) {
      this.setState({ clickedRemove: false });
      this.setState({ deleteWidget: nextProps.deleteWidgetKey });
    }
    if (this.props.marginHeight !== nextProps.marginHeight) {
      this.setState({ showDeafultMarginWidgetHeight: !this.state.showDeafultMarginWidgetHeight });
    }
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this), directionData, nextProps.selectedLang);
    }
    //---------- below code is important when multiple account with multiple margin type-----------/
    // if(this.props.DFA.MT !== nextProps.DFA.MT){
    //   if(nextProps.DFA.MT==="MT_NoMrg"){
    //     this.props.resizeMargin(2,this.state.marginWidth);
    //   } else {
    //     this.props.resizeMargin(this.props.marginHeight,this.state.marginWidth);
    //   }
    // }
  }

  closeWidget = (keyValue) => {
    try{
      this.setState({ clickedRemove: true });
      this.props.deleteWidget(keyValue);
      const { deleteWidgetKey, layout } = this.props;
      const layoutArray = layout;
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeWidget', component:"MarginComponent"});
    }
  }

  gridType = () => {
    try{
      this.setState({ showGridOptions: !this.state.showGridOptions });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'gridType', component:"MarginComponent"});
    }
  }

  closeGridType = () => {
    try{
      this.setState({ showGridOptions: false });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeGridType', component:"MarginComponent"});
    }
  }

  onClick = (e, data) => {
    try{
      this.props.resizeMargin(data.rowNumber + 1, data.columnNumber + 1);
      this.setState({ showGridOptions: false });
      //this.setState({marginWidth:data.columnNumber+1})
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onClick', component:"MarginComponent"});
    }
  }

  render() {
    const { CloseIcon, popoutIcon, keyValue } = this.props;
    const clickedRemove = this.state.clickedRemove;
    const currency = this.props.currencyData;
    const selectedfont_size = "fontSize_" + this.props.userDetail.fontSize;
    /* below values used for Margin */
    let totFundsArray = parseFloat(this.props.userDetail.isMarginWithOrders) === 1 ? Number(parseFloat(this.props.accBalMargBean.totfunds).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF })
      : Number(parseFloat(this.props.accBalMargBean.noOrdtotfunds).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF });
    let totFundsFloat = parseFloat(this.props.userDetail.isMarginWithOrders) === 1 ? Number(parseFloat(this.props.accBalMargBean.totfunds).toFixed(config.AmountRoundOFF))
      : Number(parseFloat(this.props.accBalMargBean.noOrdtotfunds).toFixed(config.AmountRoundOFF));

    let totLossLimitArray = Number(parseFloat(this.props.accBalMargBean.lossLimit).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF })
   
    let totrevalArray = parseFloat(this.props.userDetail.isMarginWithOrders) === 1 ? Number(parseFloat(this.props.accBalMargBean.totReval).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF })
      : Number(parseFloat(this.props.accBalMargBean.noOrdtotReval).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF });
    let totrevalFloat = parseFloat(this.props.userDetail.isMarginWithOrders) === 1 ? Number(parseFloat(this.props.accBalMargBean.totReval).toFixed(config.AmountRoundOFF))
      : Number(parseFloat(this.props.accBalMargBean.noOrdtotReval).toFixed(config.AmountRoundOFF));

    let totMargin = parseFloat(this.props.userDetail.isMarginWithOrders) === 1 ? Number(parseFloat(this.props.accBalMargBean.totmargin).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF })
      : Number(parseFloat(this.props.accBalMargBean.noOrdtotmargin).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF });
    let totMarginFloat = parseFloat(this.props.userDetail.isMarginWithOrders) === 1 ? Number(parseFloat(this.props.accBalMargBean.totmargin).toFixed(config.AmountRoundOFF))
      : Number(parseFloat(this.props.accBalMargBean.noOrdtotmargin).toFixed(config.AmountRoundOFF));

    let totExcess = parseFloat(this.props.userDetail.isMarginWithOrders) === 1 ? Number(parseFloat(this.props.accBalMargBean.excess).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF })
      : Number(parseFloat(this.props.accBalMargBean.noOrdexcess).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF });
    let totExcessFloat = parseFloat(this.props.userDetail.isMarginWithOrders) === 1 ? Number(parseFloat(this.props.accBalMargBean.excess).toFixed(config.AmountRoundOFF))
      : Number(parseFloat(this.props.accBalMargBean.noOrdexcess).toFixed(config.AmountRoundOFF));

    let totMarginPerc = parseFloat(this.props.userDetail.isMarginWithOrders) === 1 ? Number(parseFloat(this.props.accBalMargBean.margPerc).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF })
      : Number(parseFloat(this.props.accBalMargBean.noOrdmargPerc).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF });
    let totMarginPercFloat = parseFloat(this.props.userDetail.isMarginWithOrders) === 1 ? Number(parseFloat(this.props.accBalMargBean.margPerc).toFixed(config.AmountRoundOFF))
      : Number(parseFloat(this.props.accBalMargBean.noOrdmargPerc).toFixed(config.AmountRoundOFF));

    let Excess = totExcess >= "0" ? i18next.t('excess') : i18next.t('short');
    let marginPercentLable = Number(parseFloat(this.props.accBalMargBean.margPercLable)).toLocaleString(navigator.language);

    let netEquity = parseFloat(this.props.userDetail.isMarginWithOrders) === 1 ? Number((parseFloat(this.props.accBalMargBean.totReval) + parseFloat(this.props.accBalMargBean.totfunds)).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF })
      : Number((parseFloat(this.props.accBalMargBean.noOrdtotReval) + parseFloat(this.props.accBalMargBean.noOrdtotfunds)).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF });
    let netEquityArray = parseFloat(this.props.userDetail.isMarginWithOrders) === 1 ? (parseFloat(this.props.accBalMargBean.totReval) + parseFloat(this.props.accBalMargBean.totfunds))
      : (parseFloat(this.props.accBalMargBean.noOrdtotReval) + parseFloat(this.props.accBalMargBean.noOrdtotfunds));
    totMarginPerc = totMarginPerc + " %";

    /* below values used for No Margin */
    let totalFundsNoMarginOrd = Number(parseFloat(this.props.accBalMargBean.totalFundsNoMarginOrd).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF })

    let buyOrdFunds = Number(parseFloat(this.props.accBalMargBean.buyOrdFunds).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF })

    let netFund = Number(parseFloat(this.props.accBalMargBean.netFunds).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF })

    let noMrgOrdLossLimt = Number(parseFloat(this.props.accBalMargBean.noMrgOrdLossLimt).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF })
    
    let noMrgRevaluationArray = Number(parseFloat(this.props.accBalMargBean.noMrgRevaluation)?.toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF })
    let noMrgRevalFloat = Number(parseFloat(this.props.accBalMargBean.noMrgRevaluation)?.toFixed(config.AmountRoundOFF))
    
    let noMrgNetEquity = Number((this.props.accBalMargBean.noMrgNetEquity)?.toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language, { minimumFractionDigits: config.AmountRoundOFF })
    let noMrgNetEquityArray = this.props.accBalMargBean.noMrgNetEquity
    
    return (
      <div id="marginMainDiv" className={styles.marginDiv}>
        {!clickedRemove ? <div id="statuspart">
          <div className='headerInner'>
            <div className="widgetheader">
              <span className={`${selectedfont_size} ${styles.widgettitle} widgettitle`}>
                {this.props.userDetail.newRiskCheckType === "MT_NoMrg" || (this.props.userDetail.newRiskCheckType === "MT_AsPerAcc" && this.props.DFA.MT === "MT_NoMrg") ? i18next.t('position') : i18next.t('margin')}
              </span>
              {this.props.userDetail.newRiskCheckType === "MT_Perc" || (this.props.userDetail.newRiskCheckType === "MT_AsPerAcc" && this.props.DFA.MT === "MT_Perc") ? <span onClick={() => this.gridType()} className="vericalDotIcon"></span> : null}
              <div className={`resizeLayout`}>
                <HoverTable
                  column={1}
                  row={2}
                  width={22}
                  height={46}
                  selectedRow={this.props.height - 1}
                  selectedColumn={this.props.width - 1}
                  onClick={this.onClick}
                  showDimension={true} // show dimension or not
                  onMouseOut={this.onMouseOut}
                  onMouseOver={this.onMouseOver}
                  theme="light"
                  defaultColumn={0}
                  defaultRow={0}
                />
              </div>
              <span onClick={() => this.closeWidget(keyValue)} id="closewidgetIcon">{CloseIcon}</span>
            </div>
          </div>

          <div className={`${styles.widgetbody}`} onClick={() => this.closeGridType()}>
            {this.props.userDetail.newRiskCheckType === "MT_NoMrg" || (this.props.userDetail.newRiskCheckType === "MT_AsPerAcc" && this.props.DFA.MT === "MT_NoMrg") ?
              <React.Fragment>
                <div className={`${styles.fieldWrapper}`}>
                  <label className={`${selectedfont_size} ${styles.widgetlabel} mrgnLbl`}>
                    {i18next.t('totalFund') + " (" + this.props.localCurrency[0]?.basecurrency + ")"}
                  </label>
                  <div className={this.props.userDetail.fontSize === 'B' ? `${styles.widgetfield1} ${selectedfont_size} mrgnInputDiv` : `${styles.widgetfield} ${selectedfont_size} mrgnInputDiv`}>
                    <input ref="totalFunds" value={totalFundsNoMarginOrd} type="text" className={`${styles.inputfield} ${styles.up} mrgnField`} />
                  </div>
                </div>

                <div className={`${styles.fieldWrapper}`}>
                  <label className={`${selectedfont_size} ${styles.widgetlabel} mrgnLbl`}>
                    {i18next.t('revaluation')}
                  </label>
                  <div className={this.props.userDetail.fontSize === 'B' ? `${styles.widgetfield1} ${selectedfont_size} mrgnInputDiv` : `mrgnInputDiv ${styles.widgetfield} ${selectedfont_size}`}>
                    <input ref="Revaluation" value={noMrgRevaluationArray} type="text" className={noMrgRevalFloat > 0 ? `${styles.inputfield} ${styles.up} mrgnField` : `${styles.inputfield} ${styles.down} mrgnField`} />
                  </div>
                </div>
                {/* Added USD for netEquity */}
                {this.state.showDeafultMarginWidgetHeight == true ?
                  <div className={`${styles.fieldWrapper}`}>
                    <label className={`${selectedfont_size} ${styles.widgetlabel} mrgnLbl`}>
                      {i18next.t('netEquity') + " (" + this.props.localCurrency[0]?.basecurrency + ")"}
                    </label>
                    <div className={this.props.userDetail.fontSize === 'B' ? `${styles.widgetfield1} ${selectedfont_size} mrgnInputDiv` : `mrgnInputDiv ${styles.widgetfield} ${selectedfont_size}`}>
                      <input ref="MarGn" value={noMrgNetEquity} type="text" className={noMrgNetEquityArray > 0 ? `${styles.inputfielddiff} ${styles.up} mrgnField` : `${styles.inputfielddiff} ${styles.down} mrgnField`} />
                    </div>
                  </div>
                  : null}

                {this.props.userDetail.ELL === true ?
                  <div className={`${styles.fieldWrapper}`}>
                    <label className=
                    
                    {`${selectedfont_size} ${styles.widgetlabel} mrgnLbl`}>
                      {i18next.t('lossLmt')}
                    </label>
                    <div className={this.props.userDetail.fontSize === 'B' ? `${styles.widgetfield1} ${selectedfont_size} mrgnInputDiv` : `${styles.widgetfield} ${selectedfont_size} mrgnInputDiv`}>
                      <input ref="lossLmt" value={noMrgOrdLossLimt} type="text" className={`${styles.inputfield} ${styles.up} mrgnField`} />
                    </div>
                  </div> 
                  : null}

                <div className={`${styles.fieldWrapper}`}>
                  <label className={`${selectedfont_size} ${styles.widgetlabel} mrgnLbl`}>
                    {i18next.t('buyOrders')}
                  </label>
                  <div className={this.props.userDetail.fontSize === 'B' ? `${styles.widgetfield1} ${selectedfont_size} mrgnInputDiv` : `${styles.widgetfield} ${selectedfont_size} mrgnInputDiv`}>
                    <input ref="buyOrders" value={buyOrdFunds} type="text" className={`${styles.inputfield} ${styles.down} mrgnField`} />
                  </div>
                </div>

                <div className={`${styles.fieldWrapper}`}>
                  <label className={`${selectedfont_size} ${styles.widgetlabel} ${styles.netBold} mrgnLbl`}>
                    {i18next.t('netFundsUSD') + " (" + this.props.localCurrency[0].basecurrency + ")"}
                  </label>
                  <div className={this.props.userDetail.fontSize === 'B' ? `${styles.widgetfield1} ${selectedfont_size} mrgnInputDiv` : `${styles.widgetfield} ${selectedfont_size} mrgnInputDiv`}>
                    <input ref="netFundsUSD" value={netFund} type="text" className={`${styles.inputfield} ${styles.up} ${styles.netBold} mrgnField`} />
                  </div>
                </div>

                <div className="divider"></div>

                {this.state.detbean.map((item, index) => {
                  {/*let netPos=Number((parseFloat(item.Q) + parseFloat(item.OQ)).toFixed(config.QuantityRoundOff)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })
                      let netPosFloat=(parseFloat(item.Q) + parseFloat(item.OQ))*/}
                  return (
                    <React.Fragment>
                      <div className={`${styles.fieldWrapper}`}>
                        <label className={`${selectedfont_size} ${styles.widgetlabel} mrgnLbl`}>
                          {i18next.t('position-')} {this.props.dropdown.cmdty_metal.indexOf(item.D) !== -1 ? `${item.D} ${this.props.userDetail.CompanyBaseName}` : item.D}
                        </label>
                        <div className={this.props.userDetail.fontSize === 'B' ? `${styles.widgetfield1} ${selectedfont_size} mrgnInputDiv` : `${styles.widgetfield} ${selectedfont_size} mrgnInputDiv`}>
                          <input ref="position" value={Number(parseFloat(item.Q).toFixed(config.QuantityRoundOff)).toLocaleString(navigator.language, { minimumFractionDigits: config.QuantityRoundOff })} type="text" className={`${styles.inputfield} ${styles.up} mrgnField`} />
                        </div>
                      </div>

                      <div className={`${styles.fieldWrapper}`}>
                        <label className={`${selectedfont_size} ${styles.widgetlabel} mrgnLbl`}>
                          {i18next.t('sellOrders')}/{this.props.userDetail.isPhysicalDeliveryEnabled ? i18next.t('deliveries'): ``}
                        </label>
                        <div className={this.props.userDetail.fontSize === 'B' ? `${styles.widgetfield1} ${selectedfont_size} mrgnInputDiv` : `${styles.widgetfield} ${selectedfont_size} mrgnInputDiv`}>
                          <input ref="sellOrders" value={Number(parseFloat(item.OQ).toFixed(config.QuantityRoundOff)).toLocaleString(navigator.language, { minimumFractionDigits: config.QuantityRoundOff })} type="text" className={`${styles.inputfield} ${styles.down} mrgnField`} />
                        </div>
                      </div>

                      <div className={`${styles.fieldWrapper}`}>
                        <label className={`${selectedfont_size} ${styles.widgetlabel} ${styles.netBold} mrgnLbl`}>
                          {i18next.t('net')}{this.props.dropdown.cmdty_metal.indexOf(item.D) !== -1 ? `${item.D} ${this.props.userDetail.CompanyBaseName}` : item.D}
                        </label>
                        <div className={this.props.userDetail.fontSize === 'B' ? `${styles.widgetfield1} ${selectedfont_size} mrgnInputDiv` : `${styles.widgetfield} ${selectedfont_size} mrgnInputDiv`}>
                          <input ref="net" value={Number(parseFloat(item.NP).toFixed(config.QuantityRoundOff)).toLocaleString(navigator.language, { minimumFractionDigits: config.QuantityRoundOff })} type="text" className={`${styles.inputfield} ${styles.up} ${styles.netBold} mrgnField`} />
                        </div>
                      </div>

                      <div className="divider"></div>
                    </React.Fragment>
                  );
                })}
              </React.Fragment>
              :
              <React.Fragment>
                <div className={`${styles.fieldWrapper}`}>
                  <label className={`${selectedfont_size} ${styles.widgetlabel} mrgnLbl`}>
                    {i18next.t('totalFund')}
                  </label>
                  <div className={this.props.userDetail.fontSize === 'B' ? `${styles.widgetfield1} ${selectedfont_size} mrgnInputDiv` : `${styles.widgetfield} ${selectedfont_size} mrgnInputDiv`}>
                    <input ref="totalFunds" value={totFundsArray} type="text" className={totFundsFloat > 0 ? `${styles.inputfield} ${styles.up} mrgnField` : `${styles.inputfield} ${styles.down} mrgnField`} />
                  </div>
                </div> 

                <div className={`${styles.fieldWrapper}`}>
                  <label className={`${selectedfont_size} ${styles.widgetlabel} mrgnLbl`}>
                    {i18next.t('revaluation')}
                  </label>
                  <div className={this.props.userDetail.fontSize === 'B' ? `${styles.widgetfield1} ${selectedfont_size} mrgnInputDiv` : `mrgnInputDiv ${styles.widgetfield} ${selectedfont_size}`}>
                    <input ref="Revaluation" value={totrevalArray} type="text" className={totrevalFloat > 0 ? `${styles.inputfield} ${styles.up} mrgnField` : `${styles.inputfield} ${styles.down} mrgnField`} />
                  </div>
                </div>

                {this.state.showDeafultMarginWidgetHeight == true ?
                  <div className={`${styles.fieldWrapper}`}>
                    <label className={`${selectedfont_size} ${styles.widgetlabel} mrgnLbl`}>
                      {i18next.t('netEquity')}
                    </label>
                    <div className={this.props.userDetail.fontSize === 'B' ? `${styles.widgetfield1} ${selectedfont_size} mrgnInputDiv` : `mrgnInputDiv ${styles.widgetfield} ${selectedfont_size}`}>
                      <input ref="MarGn" value={netEquity} type="text" className={netEquityArray > 0 ? `${styles.inputfielddiff} ${styles.up} mrgnField` : `${styles.inputfielddiff} ${styles.down} mrgnField`} />
                    </div>
                  </div>
                  : null}

                {this.props.userDetail.ELL ?   
                  <div className={`${styles.fieldWrapper}`}>
                    <label className={`${selectedfont_size} ${styles.widgetlabel} mrgnLbl`}>
                      {i18next.t('lossLmt')}
                    </label>
                    <div className={this.props.userDetail.fontSize === 'B' ? `${styles.widgetfield1} ${selectedfont_size} mrgnInputDiv` : `${styles.widgetfield} ${selectedfont_size} mrgnInputDiv`}>
                      <input ref="lossLmt" value={totLossLimitArray} type="text" className={`${styles.inputfield} ${styles.up} mrgnField`} />
                    </div>
                  </div> 
                  : null}

                <React.Fragment>
                  <div className={`${styles.fieldWrapper}`}>
                    <label className={`${selectedfont_size} ${styles.widgetlabel} mrgnLbl`}>
                      {i18next.t('marginAt')} {marginPercentLable}%
                    </label>
                    <div className={this.props.userDetail.fontSize === 'B' ? `${styles.widgetfield1} ${selectedfont_size} mrgnInputDiv` : `mrgnInputDiv ${styles.widgetfield} ${selectedfont_size}`}>
                      <input ref="Margin" value={totMargin} type="text" className={totMarginFloat > 0 ? `${styles.inputfield} ${styles.up} mrgnField` : `${styles.inputfield} ${styles.down} mrgnField`} />
                    </div>
                  </div>
                </React.Fragment>

                <React.Fragment>
                  <div className={`${styles.fieldWrapper}`}>
                    <label className={`${selectedfont_size} ${styles.widgetlabel} mrgnLbl`}>{Excess}</label>
                    <div className={this.props.userDetail.fontSize === 'B' ? `${styles.widgetfield1} ${selectedfont_size} mrgnInputDiv` : `mrgnInputDiv ${styles.widgetfield} ${selectedfont_size}`}>
                      <input ref="Excess" value={totExcess} type="text" className={totExcessFloat > 0 ? `${styles.inputfield} ${styles.up} mrgnField` : `${styles.inputfield} ${styles.down} mrgnField`} />
                    </div>
                  </div>
                </React.Fragment>

                {this.state.showDeafultMarginWidgetHeight != true ?
                  <div className={`${styles.fieldWrapper}`}>
                    <label className={`${selectedfont_size} ${styles.widgetlabel} mrgnLbl`}>
                      {i18next.t('marginPerc')}{this.props.userDetail.enableCustomerOrder && (parseFloat(this.props.userDetail.isMarginWithOrders) === 1 || this.props.userDetail.isMarginWithOrders !== undefined) ?
                        <span>
                          <ReactTooltip id='withOrderTooltip2' class='toolTip'>
                            <span>{i18next.t('withOrderTooltip')}</span>
                          </ReactTooltip>
                          <MUIIcon dataFor='withOrderTooltip2' icon={'Star'} className={`${styles.withOrderIcon} withOrderIcon`} style={this.props.selectedCssColorTheme.iconColor}/>
                        </span>
                        : null}
                    </label>
                    <div className={this.props.userDetail.fontSize === 'B' ? `${styles.widgetfield1} ${selectedfont_size} mrgnInputDiv` : `mrgnInputDiv ${styles.widgetfield} ${selectedfont_size}`}>
                      <input ref="MarGn" value={totMarginPerc} type="text" className={totMarginPercFloat > 0 ? `${styles.inputfielddiff} ${styles.up} mrgnField` : `${styles.inputfielddiff} ${styles.down} mrgnField`} />
                    </div>
                  </div>
                  : null}


                {this.state.showDeafultMarginWidgetHeight == true ?
                  <div className={this.props.userDetail.fontSize === 'B' ? `${styles.tableResponsive} table-responsive` : `table-responsive`}>
                    <div className={`${styles.fieldWrapper}`}>
                      <label className={`${selectedfont_size} ${styles.widgetlabel} mrgnLbl`}>
                        {i18next.t('marginPerc')}{this.props.userDetail.enableCustomerOrder && (parseFloat(this.props.userDetail.isMarginWithOrders) === 1 || this.props.userDetail.isMarginWithOrders == undefined) ?
                          <span>
                            <ReactTooltip id='withOrderTooltip1' class='toolTip'>
                              <span>{i18next.t('withOrderTooltip')}</span>
                            </ReactTooltip>
                            <MUIIcon dataFor='withOrderTooltip1' icon={'Star'} className={`${styles.withOrderIcon} withOrderIcon`} style={this.props.selectedCssColorTheme.iconColor}/>
                          </span>
                          : null}
                      </label>
                      <div className={this.props.userDetail.fontSize === 'B' ? `${styles.widgetfield1} ${selectedfont_size} mrgnInputDiv` : `mrgnInputDiv ${styles.widgetfield} ${selectedfont_size}`}>
                        <input ref="MarGn" value={totMarginPerc} type="text" className={totMarginPercFloat > 0 ? `${styles.inputfielddiff} ${styles.up} mrgnField` : `${styles.inputfielddiff} ${styles.down} mrgnField`} />
                      </div>
                    </div>

                    <div className="divider"></div>

                    <div id="mrgPosTbl" className="marginPosOuterDiv">
                      <table className={this.props.userDetail.fontSize === 'B' ? `marginPosition marginPosition1 ${selectedfont_size} mrgnTbl` : `marginPosition ${selectedfont_size} mrgnTbl`}>
                        <thead>
                          <tr>
                            <th className="mrgnTblHead">{i18next.t('cmdty')}</th>
                            <th className="mrgnTblHead">{i18next.t('quantity')}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.detbean.map((item, index) => {
                            return (
                              <tr>
                                <td>{this.props.dropdown.cmdty_metal.indexOf(item.D) !== -1 ? `${item.D} ${this.props.userDetail.CompanyBaseName}` : item.D}</td>
                                <td className={Number(parseFloat(item.Q)) > 0 ? `${styles.up} paddright` : `${styles.down} paddright`}>
                                  {Number(parseFloat(item.Q).toFixed(config.QuantityRoundOff)).toLocaleString(navigator.language, { minimumFractionDigits: config.QuantityRoundOff })}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  : null}
              </React.Fragment>
            }
          </div>
        </div>
          : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.dashboardRoot.commonReducer.modal,
    layout: state.dashboardRoot.dashboardReducer.layout,
    clickedEdit: state.dashboardRoot.dashboardReducer.clickedEdit,
    status: state.dashboardRoot.instrumentListReducer.status,
    currencyData: state.dashboardRoot.instrumentListReducer.currencyData,
    userDetail: state.auth.userDetail,
    accBalMargBean: state.dashboardRoot.instrumentListReducer.accBalMargBean,
    check: state.dashboardRoot.instrumentListReducer.check,
    marginHeight: state.dashboardRoot.dashboardReducer.marginHeight,
    selectedCssColorTheme: state.dashboardRoot.commonReducer.selectedCssColorTheme,
    fontSize: state.auth.userDetail.fontSize,
    selectedLang: state.dashboardRoot.commonReducer.selectedLang,
    localCurrency: state.dashboardRoot.instrumentListReducer.localCurrency,
    DFA: state.auth.DFA,
    dropdown: state.dashboardRoot.instrumentListReducer.dropdown
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    deleteWidget: dashboardActions.deleteWidget,
    layoutChanged: dashboardActions.layoutChanged,
    resizeMargin: dashboardActions.resizeMargin,
    logFileCreation: CommonActions.logFileCreation
  }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MarginComponent);
